import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useListConnectProducts = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'products'],
    queryFn: () => connectService.listConnectProducts()
  });

  return { products: data?.data ?? [], isLoading, error, refetch };
};
